import { getCurrentScope as A, onScopeDispose as C, computed as p, toValue as v, watch as g, ref as m, getCurrentInstance as x, onMounted as S, defineComponent as I, reactive as y, createElementBlock as N, openBlock as Q, normalizeStyle as E, renderSlot as B } from "vue";
function z(e) {
  return A() ? (C(e), !0) : !1;
}
const F = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const R = (e) => e != null;
function T(e) {
  return Array.isArray(e) ? e : [e];
}
const O = F ? window : void 0;
function w(e) {
  var i;
  const o = v(e);
  return (i = o == null ? void 0 : o.$el) != null ? i : o;
}
function H() {
  const e = m(!1), i = x();
  return i && S(() => {
    e.value = !0;
  }, i), e;
}
function M(e) {
  const i = H();
  return p(() => (i.value, !!e()));
}
function L(e, i, o = {}) {
  const { window: u = O, ...l } = o;
  let a;
  const d = M(() => u && "MutationObserver" in u), f = () => {
    a && (a.disconnect(), a = void 0);
  }, c = p(() => {
    const r = v(e), s = T(r).map(w).filter(R);
    return new Set(s);
  }), h = g(
    () => c.value,
    (r) => {
      f(), d.value && r.size && (a = new MutationObserver(i), r.forEach((s) => a.observe(s, l)));
    },
    { immediate: !0, flush: "post" }
  ), t = () => a == null ? void 0 : a.takeRecords(), n = () => {
    h(), f();
  };
  return z(n), {
    isSupported: d,
    stop: n,
    takeRecords: t
  };
}
function W(e, i, o = {}) {
  const { window: u = O, ...l } = o;
  let a;
  const d = M(() => u && "ResizeObserver" in u), f = () => {
    a && (a.disconnect(), a = void 0);
  }, c = p(() => {
    const n = v(e);
    return Array.isArray(n) ? n.map((r) => w(r)) : [w(n)];
  }), h = g(
    c,
    (n) => {
      if (f(), d.value && u) {
        a = new ResizeObserver(i);
        for (const r of n)
          r && a.observe(r, l);
      }
    },
    { immediate: !0, flush: "post" }
  ), t = () => {
    f(), h();
  };
  return z(t), {
    isSupported: d,
    stop: t
  };
}
function b(e) {
  const { from: i, to: o, duration: u, callback: l, easing: a = (c) => c * (2 - c) } = e;
  let d;
  function f(c) {
    d || (d = c);
    const h = Math.min(1, (c - d) / u), t = a(h), n = i + (o - i) * t;
    l(n), h < 1 && requestAnimationFrame(f);
  }
  requestAnimationFrame(f);
}
function V(e) {
  return e;
}
function q(e) {
  return e * e;
}
function $(e) {
  return e * (2 - e);
}
function D(e) {
  return e < 0.5 ? 2 * e * e : -1 + (4 - 2 * e) * e;
}
function G(e, i = 1.25) {
  return 1 + (e - 1) * (e - 1) * ((i + 1) * (e - 1) + i);
}
function j(e) {
  return e * e * e;
}
function J(e) {
  return --e * e * e + 1;
}
function K(e) {
  return e < 0.5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1;
}
function U(e) {
  return e * e * e * e;
}
function X(e) {
  return 1 - --e * e * e * e;
}
function Y(e) {
  return e < 0.5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
}
function Z(e) {
  return e * e * e * e * e;
}
function _(e) {
  return 1 + --e * e * e * e * e;
}
function ee(e) {
  return e < 0.5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e;
}
const te = /* @__PURE__ */ I({
  __name: "AutoSize",
  props: {
    width: { type: Boolean, default: !0 },
    height: { type: Boolean, default: !0 },
    duration: { default: 150 },
    easing: { type: Function, default: $ }
  },
  setup(e) {
    const i = m(void 0), o = y({
      width: 0,
      height: 0
    }), u = y({
      width: 0,
      height: 0
    }), l = m(void 0), a = p(() => {
      if (o)
        switch (!0) {
          case (e.width && e.height):
            return {
              width: `${u.width}px`,
              height: `${u.height}px`
            };
          case e.width:
            return {
              width: `${u.width}px`
            };
          case e.height:
            return {
              height: `${u.height}px`
            };
          default:
            return;
        }
      else
        return;
    }), d = p(() => {
      if (i.value) {
        const t = getComputedStyle(i.value, null), n = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-left")), s = parseFloat(t.getPropertyValue("padding-right")), k = parseFloat(t.getPropertyValue("padding-bottom"));
        return { x: s + r, y: n + k };
      } else
        return { x: 0, y: 0 };
    }), f = p(() => {
      var t;
      return Array.from(((t = i.value) == null ? void 0 : t.childNodes) ?? []).find(
        (n) => n instanceof HTMLElement
      );
    });
    L(
      i,
      (t) => {
        const n = t.flatMap((s) => [...s.addedNodes]).find((s) => s instanceof HTMLElement), r = t.flatMap((s) => [...s.addedNodes]).find((s) => s instanceof Comment);
        n && n instanceof HTMLElement && (l.value = n), r && !f.value && (l.value = void 0, o.width = 0, o.height = 0), f.value || (l.value = void 0, o.width = 0, o.height = 0);
      },
      {
        childList: !0,
        subtree: !0
      }
    ), W(l, (t) => {
      const r = t[0].borderBoxSize[0];
      o.width = r.inlineSize + d.value.x, o.height = r.blockSize + d.value.y;
    }), S(() => {
      if (i.value) {
        const t = i.value.querySelectorAll("*"), n = Array.from(t).find(
          (r) => r instanceof HTMLElement
        );
        n && n instanceof HTMLElement ? (l.value = n, o.width = n.offsetWidth + d.value.x, o.height = n.offsetHeight + d.value.y) : (o.width = 0, o.height = 0), c(o.width), h(o.height);
      }
    });
    function c(t) {
      isNaN(t) || (u.width = t);
    }
    function h(t) {
      isNaN(t) || (u.height = t);
    }
    return g(
      () => o.width,
      (t) => {
        t !== u.width && b({
          from: u.width,
          to: t,
          duration: e.duration,
          easing: e.easing,
          callback: c
        });
      }
    ), g(
      () => o.height,
      (t) => {
        t !== u.width && b({
          from: u.height,
          to: t,
          duration: e.duration,
          easing: e.easing,
          callback: h
        });
      }
    ), (t, n) => {
      var r, s;
      return Q(), N("div", {
        ref_key: "elRef",
        ref: i,
        class: "auto-size",
        style: E({
          "--auto-size-width": (r = a.value) == null ? void 0 : r.width,
          "--auto-size-height": (s = a.value) == null ? void 0 : s.height,
          width: "var(--auto-size-width)",
          height: "var(--auto-size-height)"
        })
      }, [
        B(t.$slots, "default")
      ], 4);
    };
  }
});
export {
  te as AutoSize,
  j as easeInCubic,
  K as easeInOutCubic,
  D as easeInOutQuad,
  Y as easeInOutQuart,
  ee as easeInOutQuint,
  q as easeInQuad,
  U as easeInQuart,
  Z as easeInQuint,
  G as easeOutBack,
  J as easeOutCubic,
  $ as easeOutQuad,
  X as easeOutQuart,
  _ as easeOutQuint,
  b as interpolate,
  V as linear
};
